/*eslint-disable*/
import React from "react";
import {
    CrossMark,
    TooltipBox,
    ToolTipCross,
    ToolTipIcon,
    ToolTipInfo,
    ToolTipInfoText,
    ToolTipSection,
    UpArrow,
    // TooltipInfo,
    // TooltipInfoIcon,
    // TooltipWrapper,
} from "./widgets/Styled";
import PropTypes from "prop-types";

/**
 - Use an avatar for attributing actions or content to specific users.
 - The user's name should always be present when using Avatar – either printed beside the avatar or in a tooltip.
 **/
const ToolTip = (props) => {
    const {tooltipLabel, id, ToolTipStyle, toolTipPosition} = props;
    return (
        <React.Fragment>
            <ToolTipSection toolTipPosition={toolTipPosition}>
                <input type="checkbox" id={id} />
                <ToolTipIcon htmlFor={id}>
                    ?
                    <UpArrow />
                </ToolTipIcon>
                <ToolTipInfo ToolTipStyle={ToolTipStyle}>
                    <ToolTipInfoText>
                        {tooltipLabel}
                        <CrossMark htmlFor={id} toolTipPosition={toolTipPosition}>
                            <span>&times;</span>
                        </CrossMark>
                    </ToolTipInfoText>
                </ToolTipInfo>
            </ToolTipSection>
        </React.Fragment>
    );
};

ToolTip.propTypes = {
    tooltipLabel: PropTypes.string,
    id: PropTypes.string,
    ToolTipStyle: PropTypes.object,
    toolTipPosition: PropTypes.object,
};
ToolTip.defaultProps = {
    toolTipPosition: false,
};

export default ToolTip;
